import { darken, desaturate, lighten } from 'polished';
import React from 'react'
import Chart from 'react-apexcharts';
import CircleSkelitonLoader from '../../loader/CircleSkelitonLoader';

const SingleReport = ({ isVisible, handleClickInnerGraph, handleClickInnerData, singleData, singleColor }) => {
    const series_items = [singleData.quality_payment835 ?? 0, singleData.quality_payment835_lite ?? 0, singleData.quality_patientpay ?? 0, singleData.quality_correspondence ?? 0]
    const labels = ['Payment 835', 'Payment 835 Lite', 'Patient Pay', 'Correspondence']
    const curent_labels = []
    series_items?.forEach((i, index) => {
        if (i != 0) {
            curent_labels.push(labels[index])
        }
    })
    const options = {
        dataLabels: {
            enabled: true,
            style: {
                colors: ['black']
            },
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.35
            }
        },

        fill: {
            type: 'gradient',
        },
        chart: {
            id: 'basic-donut-inner',
            type: 'donut',
            toolbar: {
                show: false
            },
            fontFamily: 'Open Sans',
            events: {
                click: handleClickInnerGraph,
                dataPointSelection: handleClickInnerData
            }
        },

        legend: {
            show: true,
            customLegendItems: curent_labels,
            offsetX: 0,
            offsetY: 100,
        },
        labels: curent_labels,
        tooltip: {
            show: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                console.log("******#####!!!!!!!")
                const color = w.config.colors[seriesIndex];
                let tooltip = ''
                const mainLabel = w.globals.labels[seriesIndex]
                if (mainLabel === "Payment 835") {
                    tooltip = `${mainLabel}:${singleData?.quality_payment835}(${singleData?.payment835_error_count}/${singleData?.payment835_qa_complte})`
                }
                else if (mainLabel === "Payment 835 Lite") {
                    tooltip = `${mainLabel}:${singleData?.quality_payment835_lite}(${singleData?.payment835_lite_error_count}/${singleData?.payment835_lite_qa_complte})`
                }
                else if (mainLabel === "Patient Pay") {
                    tooltip = `${mainLabel}:${singleData?.quality_patientpay}(${singleData?.patientpay_error_count}/${singleData?.patientpay_qa_complte})`
                }
                else if (mainLabel === "Correspondence") {
                    tooltip = `${mainLabel}:${singleData?.quality_correspondence}(${singleData?.correspondance_error_count}/${singleData?.correspondance_qa_complte})`
                } return `<div style="background-color:${color};padding:5px" class="">
                        <span style="color:${"#000"};" > ${tooltip}  </span>
                </div>`

            }
        },
        colors: [darken(0.1, singleColor), singleColor, lighten(0.1, singleColor), desaturate(0.2, singleColor)],

    };
    return (
        isVisible ?
            <CircleSkelitonLoader /> :
            <Chart options={options} series={series_items?.filter(i => i > 0)} type="donut" height={'90%'} />
    )
}

export default SingleReport